import { getGlobalSearchRecentItems } from '../business-logic/use-cases/GetGlobalSearchRecentItemsUseCase'

const base = ['global-search', 'recents']

export const globalSearchRecentsQueryConfig = {
  getRecents: () => ({
    queryKey: base,
    queryFn: getGlobalSearchRecentItems,
  }),
}
